module.exports = __webpack_public_path__ + "static/media/sheduling-top.e7551310.svg";